import { getPlans, getSubscriptions } from "../apis/workspace/billing";
import { useStoreBilling } from "../stores/useStoreBIlling";
import { useSmartQuery } from "./useSmartQuery";

export const useSubscriptions = (workspaceId) => {
  const { setSubscriptions } = useStoreBilling();

  const shouldFetch = !!workspaceId;

  const query = useSmartQuery(
    ["get_subscriptions", workspaceId],
    () =>
      getSubscriptions({
        options: { headers: { "X-Workspace-Id": workspaceId } },
      }),
    {
      condition: shouldFetch, // ✅ No need to return early
      zustandSetter: setSubscriptions,
    }
  );

  return {
    ...query,
  };
};
